import Form from 'mobx-react-form';
import plugins from './plugins';

const fields = ['users', 'users[].name', 'users[].email'];

const labels = {
    users: 'All Recipients',
    'users[].email': 'Email',
    'users[].name': 'Name',
};

const placeholders = {
    users: 'All Recipients',
    'users[].email': 'Email',
    'users[].name': 'Name',
};

const rules = {
    'users[].name': 'string|required',
    'users[].email': 'required|email|string',
};


class ListForm extends Form {
    constructor(setup, options) {
        super(
            { fields, placeholders, rules, labels, ...setup },
            { plugins, ...options }
        );
    }
}

export default ListForm;
